import { Union, Record } from "../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, union_type, record_type, string_type, option_type, array_type, bool_type, int32_type } from "../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { GenericResponse_$reflection, Tickets_TimeForm_$reflection, Tickets_TimeForm, Tickets_TimeEntry_$reflection } from "../Shared/ApiDataTypes.js";
import { FetchError, FetchError_$reflection } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Result_MapError, FSharpResult$2 } from "../fable_modules/fable-library-js.4.24.0/Result.js";
import { sortByDescending, map as map_1, append } from "../fable_modules/fable-library-js.4.24.0/Array.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { corsProps, testRedirect, extraCoders } from "../Promises.js";
import { PromiseBuilder__Delay_62FBFDE1 as PromiseBuilder__Delay_62FBFDE1_1, PromiseBuilder__Run_212F1D4B as PromiseBuilder__Run_212F1D4B_1 } from "../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise as promise_1 } from "../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Types_RequestProperties } from "../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { singleton as singleton_1, cons, ofArray, empty } from "../fable_modules/fable-library-js.4.24.0/List.js";
import { some, unwrap, map, defaultArg } from "../fable_modules/fable-library-js.4.24.0/Option.js";
import { toString } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedEncoder_437914C6, Auto_generateBoxedEncoderCached_437914C6 } from "../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { comparePrimitives, equals, createObj, uncurry2 } from "../fable_modules/fable-library-js.4.24.0/Util.js";
import { MuiHelpers_createElement } from "../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { TableBody, TableHead, TableRow, Table, Typography, TableCell, IconButton, DialogContentText, DialogActions, DialogContent, Checkbox, FormControlLabel, DialogTitle, Dialog, Button, TextField, Skeleton } from "@mui/material";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../Context.js";
import { op_Subtraction, day, month, year, create, parse, addMinutes, minute, hour, toString as toString_1, now } from "../fable_modules/fable-library-js.4.24.0/Date.js";
import { Localization_Language } from "../Shared/Shared.js";
import { totalMinutes } from "../fable_modules/fable-library-js.4.24.0/TimeSpan.js";
import Restore from "@mui/icons-material/Restore";
import { empty as empty_1, singleton, append as append_1, delay, toList } from "../fable_modules/fable-library-js.4.24.0/Seq.js";
import AccessTime from "@mui/icons-material/AccessTime";
import { replace, format } from "../fable_modules/fable-library-js.4.24.0/String.js";
import { parse as parse_1 } from "../fable_modules/fable-library-js.4.24.0/Int32.js";
import { parse as parse_2 } from "../fable_modules/fable-library-js.4.24.0/Double.js";
import { sectionHeader, minutesToHoursAndMinutes } from "../TicketHelpers.js";
import { SnackError, wrapTooltip, loadingIndicatorSmall, errorBanner } from "../ViewHelpers.js";
import { useEffectOnce } from "../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { useResponsive, fromUtcToLocalString } from "../Utils.js";
import Delete from "@mui/icons-material/Delete";
import { API_Tickets_DeleteTimeEntry } from "../Shared/Urls.js";

class Model extends Record {
    constructor(TicketId, CanRegister, Entries, RegisterForm, ViewDetails, ErrorMsg) {
        super();
        this.TicketId = (TicketId | 0);
        this.CanRegister = CanRegister;
        this.Entries = Entries;
        this.RegisterForm = RegisterForm;
        this.ViewDetails = ViewDetails;
        this.ErrorMsg = ErrorMsg;
    }
}

function Model_$reflection() {
    return record_type("Kundeweb.TicketTime.Model", [], Model, () => [["TicketId", int32_type], ["CanRegister", bool_type], ["Entries", option_type(array_type(Tickets_TimeEntry_$reflection()))], ["RegisterForm", bool_type], ["ViewDetails", bool_type], ["ErrorMsg", option_type(string_type)]]);
}

class Message extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["EntriesResponse", "ToggleRegisterForm", "EntryAdded", "ToggleViewDetails", "EntriesDeleted", "DismissError"];
    }
}

function Message_$reflection() {
    return union_type("Kundeweb.TicketTime.Message", [], Message, () => [[["Item", union_type("Microsoft.FSharp.Core.FSharpResult`2", [array_type(Tickets_TimeEntry_$reflection()), FetchError_$reflection()], FSharpResult$2, () => [[["ResultValue", array_type(Tickets_TimeEntry_$reflection())]], [["ErrorValue", FetchError_$reflection()]]])]], [["Item", bool_type]], [["Item", Tickets_TimeEntry_$reflection()]], [["Item", bool_type]], [["Item", array_type(int32_type)]], []]);
}

function init(ticketId, canRegister) {
    return new Model(ticketId, canRegister, undefined, false, false, undefined);
}

function update(locale, model, msg) {
    let array_1;
    switch (msg.tag) {
        case 1:
            return new Model(model.TicketId, model.CanRegister, model.Entries, msg.fields[0], model.ViewDetails, model.ErrorMsg);
        case 2: {
            const x_2 = msg.fields[0];
            const matchValue = model.Entries;
            if (matchValue != null) {
                return new Model(model.TicketId, model.CanRegister, append(matchValue, [x_2]), false, model.ViewDetails, model.ErrorMsg);
            }
            else {
                return new Model(model.TicketId, model.CanRegister, [x_2], false, model.ViewDetails, model.ErrorMsg);
            }
        }
        case 3:
            return new Model(model.TicketId, model.CanRegister, model.Entries, model.RegisterForm, msg.fields[0], model.ErrorMsg);
        case 4: {
            const matchValue_1 = model.Entries;
            if (matchValue_1 != null) {
                return new Model(model.TicketId, model.CanRegister, (array_1 = matchValue_1, array_1.filter((r) => !msg.fields[0].some((y_1) => (r.Id === y_1)))), model.RegisterForm, false, model.ErrorMsg);
            }
            else {
                return new Model(model.TicketId, model.CanRegister, model.Entries, model.RegisterForm, false, model.ErrorMsg);
            }
        }
        case 5:
            return new Model(model.TicketId, model.CanRegister, model.Entries, model.RegisterForm, model.ViewDetails, undefined);
        default: {
            const res = msg.fields[0];
            if (res.tag === 1) {
                return new Model(model.TicketId, model.CanRegister, model.Entries, model.RegisterForm, model.ViewDetails, locale.t("TicketTime.FetchFailed"));
            }
            else {
                return new Model(model.TicketId, model.CanRegister, res.fields[0], model.RegisterForm, model.ViewDetails, model.ErrorMsg);
            }
        }
    }
}

function fetchEntries(ticketId, limit, callback) {
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr_1, decoder, data_1, caseStrategy_2, extra_2;
        const lim = (limit != null) ? (`?limit=${limit}`) : "";
        return ((pr_1 = ((decoder = Auto_generateBoxedDecoder_Z6670B51(array_type(Tickets_TimeEntry_$reflection()), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = extraCoders, (() => {
            let properties_2;
            try {
                const properties_3 = Helper_withProperties(undefined, (properties_2 = ofArray([new Types_RequestProperties(0, ["GET"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(`/api/tickets/time/${ticketId}${lim}`, properties_3).then((_arg) => {
                    let response_1, decoder_1_1;
                    return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(array_type(Tickets_TimeEntry_$reflection()), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                        let matchValue;
                        return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                    })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                }))));
                return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
            }
            catch (exn) {
                return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
            }
        })()))))), pr_1.then((result_1) => Result_MapError(testRedirect, result_1)))).then((_arg_2) => {
            callback(_arg_2);
            return Promise.resolve();
        });
    }));
    pr_2.then();
}

function drawLoading() {
    let elems;
    const loadingIndicator = () => MuiHelpers_createElement(Skeleton, [["variant", "rectangular"], ["style", {
        width: 100 + "%",
        height: 20,
    }]]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 5 + "px ",
    }], (elems = [loadingIndicator(), loadingIndicator(), loadingIndicator()], ["children", reactApi.Children.toArray(Array.from(elems))])])));
}

class RegMethod extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Hours", "Period"];
    }
}

function RegMethod_$reflection() {
    return union_type("Kundeweb.TicketTime.RegMethod", [], RegMethod, () => [[], []]);
}

function RegisterForm(registerFormInputProps) {
    let elements_2, children_4, elems_4, children_5;
    const onClose = registerFormInputProps.onClose;
    const ticketId = registerFormInputProps.ticketId;
    const ctx = reactApi.useContext(ctx_1);
    const f = new Tickets_TimeForm(ticketId, now(), 30, false, "");
    const patternInput = reactApi.useState(new RegMethod(0, []));
    const method = patternInput[0];
    const patternInput_1 = reactApi.useState(f);
    const updateForm = patternInput_1[1];
    const timeForm = patternInput_1[0];
    const patternInput_2 = reactApi.useState(true);
    const setValidHours = patternInput_2[1];
    let patternInput_3;
    const initial_3 = toString_1(now(), "yyyy-MM-dd");
    patternInput_3 = reactApi.useState(initial_3);
    const startDate = patternInput_3[0];
    let patternInput_4;
    const initial_4 = hour(now()) | 0;
    patternInput_4 = reactApi.useState(initial_4);
    const startHour = patternInput_4[0] | 0;
    let patternInput_5;
    const initial_5 = minute(now()) | 0;
    patternInput_5 = reactApi.useState(initial_5);
    const startMinute = patternInput_5[0] | 0;
    const patternInput_6 = reactApi.useState(true);
    const validStartHour = patternInput_6[0];
    const setValidStartHour = patternInput_6[1];
    const patternInput_7 = reactApi.useState(true);
    const validStartMinute = patternInput_7[0];
    const setValidStartMinute = patternInput_7[1];
    let patternInput_8;
    const initial_8 = toString_1(now(), "yyyy-MM-dd");
    patternInput_8 = reactApi.useState(initial_8);
    const endDate = patternInput_8[0];
    let patternInput_9;
    const initial_9 = hour(addMinutes(now(), 30)) | 0;
    patternInput_9 = reactApi.useState(initial_9);
    const endHour = patternInput_9[0] | 0;
    let patternInput_10;
    const initial_10 = minute(addMinutes(now(), 30)) | 0;
    patternInput_10 = reactApi.useState(initial_10);
    const endMinute = patternInput_10[0] | 0;
    const patternInput_11 = reactApi.useState(true);
    const validEndHour = patternInput_11[0];
    const setValidEndHour = patternInput_11[1];
    const patternInput_12 = reactApi.useState(true);
    const validEndMinute = patternInput_12[0];
    const setValidEndMinute = patternInput_12[1];
    const patternInput_13 = reactApi.useState(false);
    const setProcessing = patternInput_13[1];
    const patternInput_14 = reactApi.useState(undefined);
    const setErrMsg = patternInput_14[1];
    const hourSign = equals(ctx.Language, new Localization_Language(0, [])) ? "t" : "h";
    const calculateElapsed = () => {
        const sDate = parse(startDate);
        const eDate = parse(endDate);
        const fullStartDateTime = create(year(sDate), month(sDate), day(sDate), startHour, startMinute, 0);
        updateForm(new Tickets_TimeForm(timeForm.TicketId, fullStartDateTime, ~~totalMinutes(op_Subtraction(create(year(eDate), month(eDate), day(eDate), endHour, endMinute, 0), fullStartDateTime)), timeForm.Billable, timeForm.Desc));
    };
    const timeHolder = (children) => createElement("div", {
        style: {
            display: "flex",
            alignItems: "center",
            gap: 5 + "px ",
        },
        children: reactApi.Children.toArray(Array.from(children)),
    });
    const dateInput = (id, lbl, value$0027, onChange) => MuiHelpers_createElement(TextField, [["id", id], ["type", "date"], ["value", value$0027], ["size", "small"], ["variant", "outlined"], ["label", lbl], ["onChange", (e) => {
        onChange(e.target.value);
    }], ["onBlur", (_arg_3) => {
        calculateElapsed();
    }]]);
    const hourMinuteInput = (id_1, defValue, hasError, onChange_1) => MuiHelpers_createElement(TextField, [["style", {
        maxWidth: 50,
    }], ["id", id_1], ["inputProps", {
        style: {
            textAlign: "center",
        },
    }], ["defaultValue", defValue], ["variant", "outlined"], ["size", "small"], ["error", hasError], ["onChange", (e_1) => {
        onChange_1(e_1.target.value);
    }], ["onBlur", (_arg_4) => {
        calculateElapsed();
    }]]);
    const switchMethodButton = () => {
        let props_5;
        return MuiHelpers_createElement(Button, [["children", (props_5 = {}, react.createElement(Restore, props_5))], ["size", "small"], ["variant", "outlined"], ["onClick", (_arg_5) => {
            patternInput[1]((method.tag === 1) ? (new RegMethod(0, [])) : (new RegMethod(1, [])));
        }]]);
    };
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_7, v) => {
        onClose(undefined);
    }], ["PaperProps", {
        style: {
            width: 75 + "vw",
            maxWidth: 800,
        },
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("TicketTime.RegisterTime")]]), (children_4 = singleton_1(createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 10 + "px ",
    }], (elems_4 = toList(delay(() => {
        let elems_2, props_11, props_13, elems_1, copyOfStruct_10;
        return append_1((method.tag === 1) ? singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexWrap: "wrap",
            gap: 20 + "px ",
        }], (elems_2 = [switchMethodButton(), timeHolder([dateInput("start-date", ctx.Locale.t("FromDate"), startDate, (s_1) => {
            try {
                patternInput_3[1](toString_1(parse(s_1), "yyyy-MM-dd"));
            }
            catch (matchValue_2) {
            }
        }), (props_11 = {}, react.createElement(AccessTime, props_11)), hourMinuteInput("start-hour", format('{0:' + "00" + '}', startHour), !validStartHour, (h) => {
            try {
                const asInt = parse_1(h, 511, false, 32) | 0;
                if ((asInt >= 0) && (asInt < 24)) {
                    patternInput_4[1](asInt);
                    setValidStartHour(true);
                }
                else {
                    setValidStartHour(false);
                }
            }
            catch (matchValue_3) {
                setValidStartHour(false);
            }
        }), hourMinuteInput("start-minutes", format('{0:' + "00" + '}', startMinute), !validStartMinute, (m) => {
            try {
                const asInt_1 = parse_1(m, 511, false, 32) | 0;
                if ((asInt_1 >= 0) && (asInt_1 < 60)) {
                    patternInput_5[1](asInt_1);
                    setValidStartMinute(true);
                }
                else {
                    setValidStartMinute(false);
                }
            }
            catch (matchValue_4) {
                setValidStartMinute(false);
            }
        })]), timeHolder([dateInput("end-date", ctx.Locale.t("ToDate"), endDate, (s_2) => {
            try {
                patternInput_8[1](toString_1(parse(s_2), "yyyy-MM-dd"));
            }
            catch (matchValue_5) {
            }
        }), (props_13 = {}, react.createElement(AccessTime, props_13)), hourMinuteInput("end-hour", format('{0:' + "00" + '}', endHour), !validEndHour, (h_1) => {
            try {
                const asInt_2 = parse_1(h_1, 511, false, 32) | 0;
                if ((asInt_2 >= 0) && (asInt_2 < 24)) {
                    patternInput_9[1](asInt_2);
                    setValidEndHour(true);
                }
                else {
                    setValidEndHour(false);
                }
            }
            catch (matchValue_6) {
                setValidEndHour(false);
            }
        }), hourMinuteInput("end-minutes", format('{0:' + "00" + '}', endMinute), !validEndMinute, (m_1) => {
            try {
                const asInt_3 = parse_1(m_1, 511, false, 32) | 0;
                if ((asInt_3 >= 0) && (asInt_3 < 60)) {
                    patternInput_10[1](asInt_3);
                    setValidEndMinute(true);
                }
                else {
                    setValidEndMinute(false);
                }
            }
            catch (matchValue_7) {
                setValidEndMinute(false);
            }
        })])], ["children", reactApi.Children.toArray(Array.from(elems_2))])])))) : singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            gap: 20 + "px ",
        }], (elems_1 = [switchMethodButton(), MuiHelpers_createElement(TextField, [["style", {
            maxWidth: 100,
        }], ["id", "hour-method-input"], ["inputProps", {
            style: {
                textAlign: "center",
            },
        }], ["defaultValue", (copyOfStruct_10 = (timeForm.Minutes / 60), format('{0:' + "0.00" + '}', copyOfStruct_10))], ["variant", "outlined"], ["size", "small"], ["error", !patternInput_2[0]], ["label", ctx.Locale.t("Ticket.Hours")], ["onChange", (e_2) => {
            const s = e_2.target.value;
            try {
                const asFloat = parse_2(replace(replace(s.trim(), ",", "."), " ", ""));
                if (asFloat >= 0) {
                    updateForm(new Tickets_TimeForm(timeForm.TicketId, timeForm.StartTime, ~~(60 * asFloat), timeForm.Billable, timeForm.Desc));
                    setValidHours(true);
                }
                else {
                    setValidHours(false);
                }
            }
            catch (matchValue_1) {
                setValidHours(false);
            }
        }]])], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))), delay(() => {
            let elems_3;
            return append_1(singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexWrap: "wrap",
                alignItems: "center",
                gap: 10 + "px ",
            }], (elems_3 = toList(delay(() => {
                const patternInput_15 = minutesToHoursAndMinutes(timeForm.Minutes);
                return append_1(singleton(createElement("span", {
                    style: createObj(toList(delay(() => ((timeForm.Minutes < 0) ? singleton(["color", "#FF0000"]) : empty_1())))),
                    children: `${patternInput_15[0]}${hourSign} ${patternInput_15[1]}m ${ctx.Locale.t("Ticket.Hours")}`,
                })), delay(() => singleton(MuiHelpers_createElement(FormControlLabel, [["label", ctx.Locale.t("TicketTime.Billable")], ["checked", timeForm.Billable], ["onChange", (e_3) => {
                    updateForm(new Tickets_TimeForm(timeForm.TicketId, timeForm.StartTime, timeForm.Minutes, e_3.target.checked, timeForm.Desc));
                }], ["control", MuiHelpers_createElement(Checkbox, [["size", "small"], ["color", "primary"]])]]))));
            })), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => append_1(singleton(MuiHelpers_createElement(TextField, [["fullWidth", true], ["variant", "outlined"], ["label", ctx.Locale.t("SparePart.Description")], ["onChange", (e_4) => {
                updateForm(new Tickets_TimeForm(timeForm.TicketId, timeForm.StartTime, timeForm.Minutes, timeForm.Billable, e_4.target.value));
            }], ["multiline", true]])), delay(() => singleton(errorBanner(patternInput_14[0], () => {
                setErrMsg(undefined);
            }))))));
        }));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children_4))]])), (children_5 = toList(delay(() => (patternInput_13[0] ? singleton(loadingIndicatorSmall()) : append_1(singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_9) => {
        onClose(undefined);
    }]])), delay(() => singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["disabled", (((!validStartHour ? true : !validStartMinute) ? true : !validEndHour) ? true : !validEndMinute) ? true : (timeForm.Minutes < 0)], ["children", ctx.Locale.t("Register")], ["onClick", (_arg_10) => {
        const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
            let body, decoder, data_1, caseStrategy_3, extra_3;
            const sDate_1 = parse(startDate);
            const eDate_1 = parse(endDate);
            const fullStartDateTime_1 = create(year(sDate_1), month(sDate_1), day(sDate_1), startHour, startMinute, 0);
            const fullEndDateTime_1 = create(year(eDate_1), month(eDate_1), day(eDate_1), endHour, endMinute, 0);
            const req = new Tickets_TimeForm(timeForm.TicketId, fullStartDateTime_1, (method.tag === 1) ? ~~totalMinutes(op_Subtraction(fullEndDateTime_1, fullStartDateTime_1)) : timeForm.Minutes, timeForm.Billable, timeForm.Desc);
            if (req.Minutes >= 0) {
                setProcessing(true);
                return ((body = Auto_generateBoxedEncoder_437914C6(Tickets_TimeForm_$reflection(), undefined, undefined, undefined)(req), (decoder = Auto_generateBoxedDecoder_Z6670B51(Tickets_TimeEntry_$reflection(), undefined, undefined), (data_1 = some(body), (caseStrategy_3 = undefined, (extra_3 = undefined, (() => {
                    let properties_2;
                    try {
                        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                        const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch("/api/tickets/time", properties_3).then((_arg) => {
                            let response_1, decoder_1_1;
                            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(Tickets_TimeEntry_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_1) => {
                                let matchValue;
                                return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                        }))));
                        return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                    }
                    catch (exn) {
                        return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                    }
                })())))))).then((_arg_2) => {
                    const res = _arg_2;
                    if (res.tag === 1) {
                        const err = res.fields[0];
                        setErrMsg((err.tag === 2) ? (((err.fields[0].status) === 403) ? ctx.Locale.t("TicketTime.RegisterUnauthorized") : ctx.Locale.t("TicketTime.RegisterFailed")) : ctx.Locale.t("TicketTime.RegisterFailed"));
                        setProcessing(false);
                        return Promise.resolve();
                    }
                    else {
                        onClose(res.fields[0]);
                        return Promise.resolve();
                    }
                });
            }
            else {
                return Promise.resolve();
            }
        }));
        pr_1.then();
    }]]))))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_5))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

function DrawDetails(drawDetailsInputProps) {
    let elements_2, children_5, children_6;
    const onClose = drawDetailsInputProps.onClose;
    const ticketId = drawDetailsInputProps.ticketId;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(undefined);
    const setEntries = patternInput[1];
    const entries = patternInput[0];
    const patternInput_1 = reactApi.useState(undefined);
    const setDeleteForm = patternInput_1[1];
    const deleteForm = patternInput_1[0];
    const patternInput_2 = reactApi.useState(new Int32Array([]));
    const deletedIds = patternInput_2[0];
    const patternInput_3 = reactApi.useState(undefined);
    const setErrMsg = patternInput_3[1];
    const patternInput_4 = reactApi.useState(false);
    const setProcessing = patternInput_4[1];
    const hourSign = (ctx.Language.tag === 0) ? "t" : "h";
    useEffectOnce(() => {
        fetchEntries(ticketId, undefined, (_arg_1) => {
            if (_arg_1.tag === 1) {
            }
            else {
                setEntries(_arg_1.fields[0]);
            }
        });
    });
    return MuiHelpers_createElement(Dialog, [["open", true], ["onClose", (_arg_7, v) => {
        onClose(deletedIds);
    }], ["PaperProps", {
        style: {
            width: 75 + "vw",
            maxWidth: 800,
        },
    }], (elements_2 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("TicketTime.TimeEntries")]]), (children_5 = toList(delay(() => {
        let elems_3;
        return append_1((deleteForm != null) ? singleton(MuiHelpers_createElement(DialogContentText, [["children", ctx.Locale.t("TicketTime.ConfirmDelete")]])) : singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            flexDirection: "column",
            gap: 20 + "px ",
            backgroundColor: "#f6f6f6",
            padding: 10,
        }], (elems_3 = ((entries != null) ? map_1((r_2) => {
            let elems_2, elems, children, children_2, elems_1, child_2, props_8;
            const patternInput_5 = minutesToHoursAndMinutes(r_2.Minutes);
            return createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                border: (((1 + "px ") + "solid") + " ") + "#dedede",
                borderRadius: 5,
                padding: 10,
                backgroundColor: "#FFFFFF",
            }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexWrap: "wrap",
                justifyContent: "space-between",
                gap: 40 + "px ",
                borderBottom: (((1 + "px ") + "solid") + " ") + "#dedede",
                paddingBottom: 10,
            }], (elems = [(children = ofArray([`${fromUtcToLocalString(r_2.StartTime)} - `, createElement("b", {
                children: [`${patternInput_5[0]}${hourSign} ${patternInput_5[1]}m`],
            })]), createElement("span", {
                children: reactApi.Children.toArray(Array.from(children)),
            })), createElement("span", {
                children: `${r_2.Account.Email} - ${fromUtcToLocalString(r_2.Registered)}`,
            })], ["children", reactApi.Children.toArray(Array.from(elems))])]))), (children_2 = singleton_1(createElement("p", {
                style: {
                    whiteSpace: "pre-wrap",
                },
                children: r_2.Desc,
            })), createElement("div", {
                children: reactApi.Children.toArray(Array.from(children_2)),
            })), createElement("div", createObj(ofArray([["style", {
                borderTop: (((1 + "px ") + "solid") + " ") + "#dedede",
                paddingTop: 10,
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
            }], (elems_1 = [createElement("span", {
                children: [`${ctx.Locale.t("TicketTime.Billable")}: ${r_2.Billable ? ctx.Locale.t("Yes") : ctx.Locale.t("No")}`],
            }), (child_2 = MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_8 = {}, react.createElement(Delete, props_8))], ["onClick", (_arg_5) => {
                setDeleteForm(r_2);
            }]]), wrapTooltip(ctx.Locale.t("Delete"), child_2))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])])));
        }, sortByDescending((r_1) => r_1.StartTime, entries, {
            Compare: comparePrimitives,
        })) : [loadingIndicatorSmall()]), ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => singleton(errorBanner(patternInput_3[0], () => {
            setErrMsg(undefined);
        }))));
    })), MuiHelpers_createElement(DialogContent, [["children", reactApi.Children.toArray(Array.from(children_5))]])), (children_6 = toList(delay(() => {
        if (deleteForm != null) {
            const df = deleteForm;
            return patternInput_4[0] ? singleton(loadingIndicatorSmall()) : append_1(singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["color", "primary"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_10) => {
                setErrMsg(undefined);
            }]])), delay(() => singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["children", ctx.Locale.t("Delete")], ["onClick", (_arg_11) => {
                const entryId = df.Id | 0;
                const pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let decoder, data_1, caseStrategy_2, extra_2;
                    const url = API_Tickets_DeleteTimeEntry(entryId);
                    return ((decoder = Auto_generateBoxedDecoder_Z6670B51(GenericResponse_$reflection(), undefined, undefined), (data_1 = undefined, (caseStrategy_2 = undefined, (extra_2 = undefined, (() => {
                        let properties_2;
                        try {
                            const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["DELETE"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty()), 0)])]), defaultArg(map((data_1_1) => cons(new Types_RequestProperties(2, [toString(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_2), unwrap(extra_2))(data_1_1))]), properties_2), data_1), properties_2)));
                            const pr = PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Helper_fetch(url, properties_3).then((_arg_2) => {
                                let response_1, decoder_1_1;
                                return ((response_1 = _arg_2, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(GenericResponse_$reflection(), unwrap(caseStrategy_2), unwrap(extra_2))), PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (response_1.text().then((_arg_3) => {
                                    let matchValue_1;
                                    return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_3), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                                })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                            }))));
                            return pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])]))));
                        }
                        catch (exn) {
                            return PromiseBuilder__Run_212F1D4B_1(promise_1, PromiseBuilder__Delay_62FBFDE1_1(promise_1, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                        }
                    })()))))).then((_arg_4) => {
                        let array;
                        const res = _arg_4;
                        if (res.tag === 0) {
                            const r = res.fields[0];
                            if (r.Result === "success") {
                                setProcessing(false);
                                patternInput_2[1](append(new Int32Array([entryId]), deletedIds, Int32Array));
                                setDeleteForm(undefined);
                                return ((entries != null) ? ((setEntries((array = entries, array.filter((z) => (z.Id !== entryId)))), Promise.resolve())) : (Promise.resolve())).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
                                    setErrMsg(undefined);
                                    return Promise.resolve();
                                }));
                            }
                            else {
                                setProcessing(false);
                                setErrMsg(r.Message);
                                return Promise.resolve();
                            }
                        }
                        else {
                            const err = res.fields[0];
                            setErrMsg((err.tag === 2) ? (((err.fields[0].status) === 401) ? ctx.Locale.t("TicketTime.DeleteUnauthorized") : ctx.Locale.t("TicketTime.DeleteFailed")) : ctx.Locale.t("TicketTime.DeleteFailed"));
                            setProcessing(false);
                            return Promise.resolve();
                        }
                    });
                }));
                pr_1.then();
            }]]))));
        }
        else {
            return singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["color", "primary"], ["children", ctx.Locale.t("Close")], ["onClick", (_arg_9) => {
                onClose(deletedIds);
            }]]));
        }
    })), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_6))]]))], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
}

/**
 * Component for fetching, displaying and editing a time entries
 */
export function TimeEntries(timeEntriesInputProps) {
    let elems_7, elems_6;
    const canRegister = timeEntriesInputProps.canRegister;
    const ticketId = timeEntriesInputProps.ticketId;
    const ctx = reactApi.useContext(ctx_1);
    let patternInput;
    const arg_1 = init(ticketId, canRegister);
    patternInput = reactApi.useReducer((model, msg) => update(ctx.Locale, model, msg), arg_1);
    const model_1 = patternInput[0];
    const dispatch = patternInput[1];
    const responsive = useResponsive(undefined);
    const isBig = (responsive === "wideScreen") ? true : (responsive === "desktop");
    useEffectOnce(() => {
        fetchEntries(ticketId, 5, (arg_2) => {
            dispatch(new Message(0, [arg_2]));
        });
    });
    const hourSign = (ctx.Language.tag === 0) ? "t" : "h";
    const th$0027 = (txt) => MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "head"], ["children", txt]]);
    const td$0027 = (txt_1) => MuiHelpers_createElement(TableCell, [["size", "small"], ["variant", "body"], ["children", txt_1]]);
    return createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
    }], (elems_7 = [createElement(SnackError, {
        errMsg: unwrap(model_1.ErrorMsg),
        dismiss: () => {
            dispatch(new Message(5, []));
        },
    }), sectionHeader(ctx.Locale.t("TicketTime.TimeEntries")), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        padding: 5,
        border: (((1 + "px ") + "solid") + " ") + "#dedede",
    }], (elems_6 = toList(delay(() => {
        const matchValue_1 = model_1.Entries;
        if (matchValue_1 != null) {
            const x = matchValue_1;
            return append_1(model_1.RegisterForm ? singleton(createElement(RegisterForm, {
                ticketId: ticketId,
                onClose: (newEntry) => {
                    if (newEntry != null) {
                        dispatch(new Message(2, [newEntry]));
                    }
                    else {
                        dispatch(new Message(1, [false]));
                    }
                },
            })) : empty_1(), delay(() => append_1((x.length === 0) ? singleton(MuiHelpers_createElement(Typography, [["variant", "caption"], ["children", ctx.Locale.t("TicketTime.NoEntries")]])) : append_1(model_1.ViewDetails ? singleton(createElement(DrawDetails, {
                ticketId: ticketId,
                onClose: (deletedIds) => {
                    if (deletedIds.length === 0) {
                        dispatch(new Message(3, [false]));
                    }
                    else {
                        dispatch(new Message(4, [deletedIds]));
                    }
                },
            })) : empty_1(), delay(() => {
                let elements_4, children_1, children, children_3;
                return singleton(MuiHelpers_createElement(Table, [["size", "small"], (elements_4 = [(children_1 = singleton_1((children = ofArray([th$0027(""), th$0027(ctx.Locale.t("Login.Email")), th$0027(ctx.Locale.t("TicketTime.Billable")), th$0027(ctx.Locale.t("Ticket.Hours"))]), MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children))]]))), MuiHelpers_createElement(TableHead, [["children", reactApi.Children.toArray(Array.from(children_1))]])), (children_3 = map_1((a_1) => {
                    const patternInput_1 = minutesToHoursAndMinutes(a_1.Minutes);
                    const children_2 = toList(delay(() => append_1(isBig ? singleton(td$0027(fromUtcToLocalString(a_1.StartTime))) : empty_1(), delay(() => append_1(singleton(td$0027(a_1.Account.Email)), delay(() => append_1(singleton(td$0027(a_1.Billable ? ctx.Locale.t("Yes") : ctx.Locale.t("No"))), delay(() => singleton(td$0027(`${patternInput_1[0]}${hourSign} ${patternInput_1[1]}m`))))))))));
                    return MuiHelpers_createElement(TableRow, [["children", reactApi.Children.toArray(Array.from(children_2))]]);
                }, sortByDescending((a) => a.StartTime, x, {
                    Compare: comparePrimitives,
                })), MuiHelpers_createElement(TableBody, [["children", reactApi.Children.toArray(Array.from(children_3))]]))], ["children", reactApi.Children.toArray(Array.from(elements_4))])]));
            })), delay(() => {
                let elems_5;
                return singleton(createElement("div", createObj(ofArray([["style", {
                    marginTop: 10,
                    display: "flex",
                    gap: 10 + "px ",
                }], (elems_5 = toList(delay(() => append_1(model_1.CanRegister ? singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["children", ctx.Locale.t("Register")], ["onClick", (_arg_2) => {
                    dispatch(new Message(1, [true]));
                }]])) : empty_1(), delay(() => ((x.length > 0) ? singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["color", "primary"], ["children", ctx.Locale.t("TicketTime.ViewAll")], ["onClick", (_arg_3) => {
                    dispatch(new Message(3, [true]));
                }]])) : empty_1()))))), ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
            }))));
        }
        else {
            return singleton(drawLoading());
        }
    })), ["children", reactApi.Children.toArray(Array.from(elems_6))])])))], ["children", reactApi.Children.toArray(Array.from(elems_7))])])));
}

